// Networks.tsx
import React from "react";
import "./Networks.css";
import { ScrollSVG } from "../../../constants/svgs";
import { useI18n } from "../../../i18n/i18n";

type Props = {
    extended?: boolean;
    /** id of the element we want to scroll to */
    scrollTargetId?: string;
};

const Networks: React.FC<Props> = ({ extended = false, scrollTargetId = "contacto" }) => {
    const { t } = useI18n();

    const scrollToTarget = (id: string) => {
        if (typeof window === "undefined") return;

        const target = document.getElementById(id);
        if (target) {
            target.scrollIntoView({ behavior: "smooth", block: "start" });
            return;
        }

        // fallback
        const root = document.scrollingElement || document.documentElement;
        root.scrollTo({ top: root.scrollTop + window.innerHeight, behavior: "smooth" });
    };

    const handleContactClick = () => {
        // Prefer mobile contact if present, otherwise desktop
        const mobile = document.getElementById("contacto-mobile");
        const desktop = document.getElementById("contacto");

        if (mobile) {
            scrollToTarget("contacto-mobile");
            return;
        }
        if (desktop) {
            scrollToTarget("contacto");
            return;
        }

        // fallback if neither exists
        scrollToTarget(scrollTargetId);
    };

    return (
        <div className="d-flex jcsb aic" style={{ color: "#FFFFFF" }}>
            {scrollTargetId !== "-1" && (
                <div
                    style={{ textDecoration: "underline" }}
                    className="fs14 fw700 pointer"
                    onClick={handleContactClick}
                    role="button"
                    tabIndex={0}
                    onKeyDown={(e) => {
                        if (e.key === "Enter" || e.key === " ") handleContactClick();
                    }}
                >
                    {t("nav.contact")}
                </div>
            )}

            {extended && (
                <button
                    type="button"
                    onClick={() => scrollToTarget(scrollTargetId)}
                    className="scroll-btn"
                    aria-label={t("aria.scrollDown")}
                >
                    <ScrollSVG />
                </button>
            )}

            <span style={{ width: 60 }} />
        </div>
    );
};

export default Networks;
